import { createGroupId } from '../utils/annotationGroupUtils';

export const GROUP_SELECTED_ANNOTATIONS = 'GROUP_SELECTED_ANNOTATIONS';

const groupSelectedAnnotations = (state, payload = {}) => {
  const { annotationIds = [] } = payload;
  const movableIds = annotationIds.filter(
    (id) => state.annotations[id] && !state.annotations[id].locked,
  );

  if (movableIds.length < 2) {
    return state;
  }

  const groupId = createGroupId();
  const annotations = { ...state.annotations };

  movableIds.forEach((id) => {
    annotations[id] = {
      ...annotations[id],
      groupId,
    };
  });

  return {
    ...state,
    isDesignState: true,
    annotations,
    selectionsIds: movableIds,
  };
};

export default groupSelectedAnnotations;
